import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
const Login = resolve => require(['@/components/Login'], resolve);
const SignUp = resolve => require(['@/components/SignUp'], resolve);
const SignUpStore = resolve => require(['@/components/SignUpStore'], resolve);
const CheckPhone = resolve => require(['@/components/signUp/CheckPhone'], resolve);
const CheckPhoneStore = resolve => require(['@/components/signUp/CheckPhoneStore'], resolve);
const InputInfo = resolve => require(['@/components/signUp/InputInfo'], resolve);
const InputInfoStore = resolve => require(['@/components/signUp/InputInfoStore'], resolve);
const SignUpDone = resolve => require(['@/components/signUp/SignUpDone'], resolve);
const SignUpStoreDone = resolve => require(['@/components/signUp/SignUpStoreDone'], resolve);
const GoodsList = resolve => require(['@/components/GoodsList'], resolve);
const StoresList = resolve => require(['@/components/StoresList'], resolve);
const NewsList = resolve => require(['@/components/NewsList'], resolve);
const NewsDetail = resolve => require(['@/components/NewsDetail'], resolve);
const GoodsDetail = resolve => require(['@/components/GoodsDetail'], resolve);
const StoresDetail = resolve => require(['@/components/StoresDetail'], resolve);
const ShoppingCart = resolve => require(['@/components/ShoppingCart'], resolve);
const Order = resolve => require(['@/components/Order'], resolve);
const Pay = resolve => require(['@/components/Pay'], resolve);
const PayDone = resolve => require(['@/components/PayDone'], resolve);
const Freeback = resolve => require(['@/components/Freeback'], resolve);
const Home = resolve => require(['@/components/Home'], resolve);
const MyAddress = resolve => require(['@/components/home/MyAddress'], resolve);
const AddAddress = resolve => require(['@/components/home/AddAddress'], resolve);
const MyOrder = resolve => require(['@/components/home/MyOrder'], resolve);
const MyShoppingCart = resolve => require(['@/components/home/MyShoppingCart'], resolve);
const Merchant = resolve => require(['@/components/Merchant'], resolve);

const AboutUs = resolve => require(['@/components/AboutUs'], resolve);
const AboutUsMore = resolve => require(['@/components/AboutUsMore'], resolve);
const UserPrivacy = resolve => require(['@/components/UserPrivacy'], resolve);
const ContactUs = resolve => require(['@/components/ContactUs'], resolve);

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/', // 首页
      name: 'Index',
      component: Index
    },
    {
      path: '/Login', // 登录
      name: 'Login',
      component: Login
    },
    {
      path: '/SignUp', // 注册
      name: 'SignUp',
      component: SignUp,
      children: [
        {
          path: '/',
          name: 'index',
          component: CheckPhone
        },
        {
          path: 'checkPhone',
          name: 'CheckPhone',
          component: CheckPhone
        },
        {
          path: 'inputInfo',
          name: 'InputInfo',
          component: InputInfo
        },
        {
          path: 'signUpDone',
          name: 'SignUpDone',
          component: SignUpDone
        }
      ]
    },
    {
      path: '/signUpStore', // 平台商户店铺入驻注册
      name: 'SignUpStore',
      component: SignUpStore,
      children: [
        {
          path: '/',
          name: 'index',
          component: CheckPhoneStore
        },
        {
          path: 'checkPhoneStore',
          name: 'CheckPhoneStore',
          component: CheckPhoneStore
        },
        {
          path: 'inputInfoStore',
          name: 'InputInfoStore',
          component: InputInfoStore
        },
        {
          path: 'signUpStoreDone',
          name: 'SignUpStoreDone',
          component: SignUpStoreDone
        }
      ]
    },
    {
      path: '/goodsList', // 商品列表
      name: 'GoodsList',
      component: GoodsList
    },
    {
      path: '/storesList', // 店铺列表
      name: 'StoresList',
      component: StoresList
    },
    {
      path: '/newsList', // 资讯列表
      name: 'NewsList',
      component: NewsList
    },
    {
      path: '/newsDetail', // 资讯详情
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/goodsDetail', // 商品详情
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/storesDetail', // 店铺详情
      name: 'StoresDetail',
      component: StoresDetail
    },
    {
      path: '/shoppingCart', // 商品详情
      name: 'ShoppingCart',
      component: ShoppingCart
    },
    {
      path: '/order', // 订单页面
      name: 'Order',
      component: Order
    },
    {
      path: '/pay', // 支付页面
      name: 'Pay',
      component: Pay
    },
    {
      path: '/payDone', // 支付成功页面
      name: 'PayDone',
      component: PayDone
    },
    {
      path: '/freeback', // 反馈页面
      name: 'Freeback',
      component: Freeback
    },
    {
      path: '/home', // 主页
      name: 'Home',
      component: Home,
      children: [
        {
          path: '/',
          name: 'HomeIndex',
          component: MyOrder
        },
        {
          path: 'myAddress',
          name: 'MyAddress',
          component: MyAddress
        },
        {
          path: 'addAddress',
          name: 'AddAddress',
          component: AddAddress
        },
        {
          path: 'myOrder',
          name: 'MyOrder',
          component: MyOrder
        },
        {
          path: 'myShoppingCart',
          name: 'MyShoppingCart',
          component: MyShoppingCart
        }
      ]
    },
    {
      path: '/merchant',
      name: 'Merchant',
      component: Merchant
    },

    {
      path: '/aboutUs', // 关于我们
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/aboutUsMore', // 了解我们更多
      name: 'AboutUsMore',
      component: AboutUsMore
    },
    {
      path: '/userPrivacy', // 用户使用协议
      name: 'UserPrivacy',
      component: UserPrivacy
    },
    {
      path: '/contactUs', // 联系我们
      name: 'ContactUs',
      component: ContactUs
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js